<div class="footer-container">   
    <div class="footer-item">
        <span class="disclaimer-text">{{companyName}} {{ 'publicProfiles.footer.text1' | translate:locale.language }} </span>
        <a (click)="openDialogLegalAgreements()">{{ 'publicProfiles.footer.text2' | translate:locale.language }}</a>
    </div>
    <div class="footer-item">        
        Cliniweb © {{currentYearStr}}. {{ 'publicProfiles.footer.text3' | translate:locale.language }}
    </div>
    <div class="footer-item">
        <img alt="Cliniweb: Historia Clínica Electrónica, Finanzas y Citas en Línea" src="/assets/images/cliniweb/logo-cliniweb-phr.svg">
    </div>
</div>